const FilesConfigKey = 'FILES';
const ExtraConfigKey = 'EXTRA_CONFIG';

const ConfigName = {
    legendStudy: 'LEGEND_STR',
    StepFitPlot: 'FIT_STEP_GRAPH_BOOL',
    AoIValuesInit: 'AREA_INTEREST_VALUES', //Defines if the region of interest was initialized
    Baseline_Type: 'MODEL_BASELINE_TYPE', //Defines the type of model that would be used in the Fit
		Extrapolate_Type: 'MODEL_EXTRAPOLATE_TYPE', //Defines the type of model that would be used in the Fit
    xAxisType: 'X_AXIS_TYPE', //Defines the convertion factor in x-axis
    yAxisType: 'Y_AXIS_TYPE', //Defines the convertion factor in y-axis
    fitLabel: 'CONC_UNIT', //Defines fit label
    notationFit: 'NOTATION', //Defines fit notation (units)
    rangeMaxBL: 'RANGE_MAX_BL_FLOAT',
    rangeMinBL: 'RANGE_MIN_BL_FLOAT',
    PreprocessingList: 'PREPROCESSING_1DARRAY',
    DeltaFitDiscreteGraph: 'DELTA_FIT_GRAPH_BOOL',
    SingleFitDiscreteGraph: 'SINGLE_PEAK_FIT_DISCRETE_GRAPH_BOOL',
    PeakHeightFitDiscreteGraph: 'SINGLE_PEAK_HEI_FIT_DISCRETE_GRAPH_BOOL',
    PeakAUCFitDiscreteGraph: 'SINGLE_PEAK_AUC_FIT_DISCRETE_GRAPH_BOOL',
    MeanFitDiscreteGraph: 'MEAN_FIT_DISCRETE_GRAPH_BOOL',
    ImpedanceFitDiscreteGraph: 'IMPEDANCE_FIT_DISCRETE_GRAPH_BOOL',
    OrderBPFPreProc: 'ORDER_BPF_PREPROC_FLOAT',
    F1BPFPreProc: 'F1_BPF_PREPROC_FLOAT',
    F2BPFPreProc: 'F2_BPF_PREPROC_FLOAT',
    OrderBSFPreProc: 'ORDER_BSF_PREPROC_FLOAT',
    F1BSFPreProc: 'F1_BSF_PREPROC_FLOAT',
    F2BSFPreProc: 'F2_BSF_PREPROC_FLOAT',
    OrderSavitzkyGolayPreProc: 'ORDER_SAVITZKY_PREPROC_FLOAT',
    WindowSavitzkyGolayPreProc: 'WINDOW_SAVITZKY_PREPROC_FLOAT',
    WindowMedianFilterPreProc: 'WINDOW_MEDIAN_F_PREPROC_FLOAT',
    WindowMedianAveragePreProc: 'WINDOW_MEDIAN_A_PREPROC_FLOAT',
    OrderLPFPreProc: 'ORDER_LPF_PREPROC_FLOAT',
    FCSLPFPreProc: 'FCS_LPF_PREPROC_FLOAT',
    OrderHPFPreProc: 'ORDER_HPF_PREPROC_FLOAT',
    FCSHPFPreProc: 'FCS_HPF_PREPROC_FLOAT',
		OffsetXPreProc: 'OFFSET_X_PREPROC_FLOAT',
		OffsetYPreProc: 'OFFSET_Y_PREPROC_FLOAT',
		FlipyPreProc: 'FLIPY_BOOL',
		ExtrapolateFromPreProc: 'EXTRAPOLATE_X1_PREPROC_FLOAT',
		ExtrapolateToPreProc: 'EXTRAPOLATE_X2_PREPROC_FLOAT',
		AccumulatePreProc: 'ACCUMULATE_PREPROC_BOOL',
		DifferentiatePreProc: 'DIFFERENTIATE_PREPROC_BOOL',
    MappingDiscrete: 'MAPPING_VALUES_BOOL',
    MappingScanDiscrete: 'MAPPING_SCAN_INT',
    StateTypeStudy: 'STATE_TYPE_STUDY_STRING',
    OrderBaseLineMultiple: 'ORDER_BASELINE_MULTIPLE_FLOAT',
    SSEBaseLineMultiple: 'SSE_BASELINE_MULTIPLE_FLOAT',
    CurrentDirectionReverse: 'CURRENT_DIRECTION_REVERSE_STRING',
    FeatureCheckActivate: 'FEATURE_CHECK_ACTIVATED_BOOL',
    FeatureSelectionAnalysis: 'FEATURE_SELECTION_1DARRAY',
    ValidationSelectionAnalysis: 'VALIDATION_SELECTION_STRING',
    ValidationValueAnalysis: 'VALIDATION_VALUE_FLOAT',
    ValidationValueSecondAnalysis: 'VALIDATION_VALUE_SECOND_FLOAT',
    GenericXAxisLabel: 'X_AXIS_LABEL_GENERIC',
    GenericXAxisInputUnit: 'X_AXIS_INPUT_SCALE_GENERIC',
    GenericXAxisOutputUnit: 'X_AXIS_OUTPUT_SCALE_GENERIC',
    GenericYAxisLabel: 'Y_AXIS_LABEL_GENERIC',
    GenericYAxisInputUnit: 'Y_AXIS_INPUT_SCALE_GENERIC',
    GenericYAxisOutputUnit: 'Y_AXIS_OUTPUT_SCALE_GENERIC',
    ReqExtractedValsDiscrete: 'DISCRETE_FEATURE_TABLE',
    BaseCurveFit: 'CurveFit',
    BaseFeatureCheck: 'FeatureCheck',
    BaseAxisProperties: 'AxisProperties',
    BasePropStudy: 'Properties',
    BasePreprocessing: 'PreProcessing'
};
// Extra configuration required for the manipulation of the report.
//  but it does not requires to send to the back-end
const NameExtraConfig = {
    ReverseCurrentPresent: 'REVERSE_CURRENT_PRESENT',
    MappingPresent: 'MAPPING_PRESENT',
    ScansFiles: 'SCANS_DATA_FILES',
    ShowMapping: 'SHOW_MAPPING',
    ShowState: 'SHOW_STATE',
    CopySource: 'COPY_SOURCE',
    LinkedReportChanges: 'LINKED_REPORT_CHANGES',
    ExternPayload: 'EXTERN_PAYLOAD',
    ThirdPartyBackEnd: 'THIRD_PARTY_BACKEND',
    DataSourceBackEnd: 'THIRD_PARTY_DATA_SOURCE',
};

export {
    FilesConfigKey,
    ExtraConfigKey,
    ConfigName,
    NameExtraConfig,
}